import { render, staticRenderFns } from "./param.vue?vue&type=template&id=c49f2a76"
import script from "./param.vue?vue&type=script&lang=js"
export * from "./param.vue?vue&type=script&lang=js"
import style0 from "./param.vue?vue&type=style&index=0&id=c49f2a76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports